"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundCheckScreeningStatus = void 0;
exports.instanceOfBackgroundCheckScreeningStatus = instanceOfBackgroundCheckScreeningStatus;
exports.BackgroundCheckScreeningStatusFromJSON = BackgroundCheckScreeningStatusFromJSON;
exports.BackgroundCheckScreeningStatusFromJSONTyped = BackgroundCheckScreeningStatusFromJSONTyped;
exports.BackgroundCheckScreeningStatusToJSON = BackgroundCheckScreeningStatusToJSON;
exports.BackgroundCheckScreeningStatusToJSONTyped = BackgroundCheckScreeningStatusToJSONTyped;
/**
 *
 * @export
 */
exports.BackgroundCheckScreeningStatus = {
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    Complete: 'COMPLETE',
    NeedsReview: 'NEEDS_REVIEW',
    Canceled: 'CANCELED'
};
function instanceOfBackgroundCheckScreeningStatus(value) {
    for (const key in exports.BackgroundCheckScreeningStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.BackgroundCheckScreeningStatus, key)) {
            if (exports.BackgroundCheckScreeningStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function BackgroundCheckScreeningStatusFromJSON(json) {
    return BackgroundCheckScreeningStatusFromJSONTyped(json, false);
}
function BackgroundCheckScreeningStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function BackgroundCheckScreeningStatusToJSON(value) {
    return value;
}
function BackgroundCheckScreeningStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=BackgroundCheckScreeningStatus.js.map